import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text, useResponsive } from '@common-fe/common-fe';

import Funds from './Funds';
import SellInvestmentsWrapper from './SellInvestmentsWrapper';

interface Props {
  accountId: string;
}
const SellInvestments: React.FC<Props> = ({ accountId }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <SellInvestmentsWrapper currentStep={1}>
      <Box direction="column" data-testid="sell-investments">
        <Box pad={isMobile ? { horizontal: 'spacing16' } : {}}>
          <Text size={isMobile ? '2xl' : '3xl'} data-testid="sell-investments_title" weight={700}>
            {t('Sell Investments')}
          </Text>
          <Text data-testid="sell-investments_sub-title">
            {t(
              'Sells can take up to 2 to 3 business days to be reflected in your account. Any automatic investments will be paused.'
            )}
          </Text>
        </Box>
        <Funds accountId={accountId} />
      </Box>
    </SellInvestmentsWrapper>
  );
};
export default SellInvestments;
